import { TextField } from 'edenred-ui';
import styled from 'styled-components';

export const StyledTextField = styled(TextField)`
  .MuiInputLabel-root {
    white-space: normal;
    max-width: 80%;
    line-height: 1.1;
  }
  .MuiInput-root {
    margin-top: 24px;
  }
`;
